import Moment from 'moment';

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export default {
    methods: {
        currency (number) {
            return formatter.format(number)
        },
        phone (stringNumber) {
            var regexObj = /^(?:\+?1[-. ]?)?(?:\(?([0-9]{3})\)?[-. ]?)?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (regexObj.test(stringNumber)) {
                var parts = stringNumber.match(regexObj);
                var phone = "";
                if (parts[1]) { 
                    phone += "+1 (" + parts[1] + ") "; 
                }
                phone += parts[2] + "-" + parts[3];
                return phone;
            }
            else {
                return stringNumber;
            }
        },
        
        utcToLocal (date, format) {
            return Moment.utc(date).local().format(format || "MM/DD/YYYY");
        }
    }
}
